function TrainingReportSummary() {
  return <></>;
}

export default TrainingReportSummary;
